export default {
  auth: {
    loginTitle: 'Welcome back',
    loginSubtitle: 'Log in to continue watching.',
    registerTitle: 'Create account',
    registerSubtitle: 'Register with your phone number or email to start watching.',
    account: 'Account',
    accountPlaceholder: 'Enter phone number or email',
    phoneTab: 'Phone',
    emailTab: 'Email',
    phone: 'Phone',
    phonePlaceholder: 'Enter phone number',
    email: 'Email',
    emailPlaceholder: 'Enter email',
    nickname: 'Nickname',
    nicknamePlaceholder: 'Enter nickname',
    password: 'Password',
    passwordPlaceholder: 'Enter password',
    repassword: 'Confirm',
    repasswordPlaceholder: 'Enter password again',
    loginAction: 'Log in',
    loginLoading: 'Logging in...',
    registerAction: 'Register',
    agreementPrefix: 'I have read and agree to',
    noAccount: 'No account yet?',
    hasAccount: 'Already have an account?',
    goRegister: 'Register',
    goLogin: 'Log in',
    agreementRequired: 'Please agree to the terms first',
    accountRequired: 'Please enter your account',
    passwordRequired: 'Please enter your password',
    invalidPhone: 'Please enter a valid phone number',
    invalidEmail: 'Please enter a valid email',
    invalidNickname: 'Nickname must be at least 2 characters',
    invalidPassword: 'Password must be at least 6 characters',
    passwordMismatch: 'The two passwords do not match',
    registerReady: 'Registration information is complete',
    registerSuccess: 'Registration successful',
    registerFailed: 'This account already exists or the format is invalid'
  },
  settings: {
    title: 'Settings',
    editProfile: 'Edit Profile',
    editProfileDesc: 'Update your nickname and profile information',
    changePassword: 'Change Password',
    changePasswordDesc: 'Keep your account secure',
    logout: 'Log out',
    logoutDesc: 'Sign out of this device',
    logoutConfirmTitle: 'Log out?',
    logoutConfirmMessage: 'You will need to log in again to use this account.',
    logoutConfirmAction: 'Log out',
    logoutSuccess: 'Logged out',
    cancel: 'Cancel',
    uploadAvatar: 'Upload',
    uploading: 'Uploading...',
    uploadSuccess: 'Avatar uploaded',
    uploadFailed: 'Failed to upload avatar',
    invalidAvatar: 'Please choose an image file',
    save: 'Save',
    saving: 'Saving...',
    profileEmpty: 'Please enter a nickname or upload an avatar',
    invalidNickname: 'Nickname must be at least 2 characters',
    profileUpdateSuccess: 'Profile updated',
    profileUpdateFailed: 'Failed to update profile',
    oldPassword: 'Current',
    oldPasswordPlaceholder: 'Current password',
    newPassword: 'New',
    newPasswordPlaceholder: 'New password',
    confirmPassword: 'Confirm',
    confirmPasswordPlaceholder: 'Enter again',
    passwordRequired: 'Please enter the new password',
    passwordUpdateSuccess: 'Password updated',
    passwordUpdateFailed: 'Failed to update password'
  },
  common:{
    back:"Back",
  },
  login: {
    submitText: 'One-tap Login',
    errorAccount: 'Incorrect account or password'
  },
  legal:{
    and: 'and',
    suffix:"Please agree before using",
    policy: "Privacy Policy",
    terms:"Terms of Service"
  },
  favorite: {
    empty: 'No favorites yet'
  },
  history: {
    continue: 'Continue watching',
    watched: 'Watch History',
    empty: 'No watched content yet',
    ongoing: 'Ongoing',
    completed: 'Completed',
    loading: 'Loading...',
    noMore: 'No more content',
    loadMore: 'Load more'
  },
   profile: {
    loginTitle: 'Please log in',
    loginDesc: 'Access favorites and watch history',
    loginBtn: 'Log in',
    guest: 'Guest',
    userId: 'ID',
    balance: 'View balance',
    pointsBalance: 'Balance',
    memberBadge: 'Member',
    recharge: 'Deposit',
    subscriptionTitle: 'Subscription',
    subscriptionDesc: 'View value plans for watching',
    subscriptionBtn: 'View',
    logout: 'Log out',
    menu: {
      recharge: 'Deposit',
      favorite: 'My Favorites',
      history: 'Watch History',
      rechargeHistory: 'Deposit History',
      contact: 'Contact Us'
    },
    contact: {
      support: 'Customer Support'
    }
  },
  video: {
    totalEpisodes: 'All {num} episodes',
    myPage: 'My Page',
    favorite: 'Favorites',
    episodes: 'Episodes',

    playingEpisode: 'Playing Episode {num}',
    episodeUnit: 'Ep {num}',

    buyTitle: 'Purchase',
    buySubtitle: 'Choose a method to continue',

    buySingle: 'Buy Episode',
    buySingleDesc: 'Watch this episode only',

    buyAll: 'Buy All',
    buyAllDesc: 'Unlock all episodes',
    unlockPrice: 'Price:',
    episodeShort: 'episode',
    unlockNextEpisodes: 'Next {count} episodes',
    unlockRemainingEpisodes: 'Unlock remaining',
    unlockAllEpisodes: 'Unlock all',
    upgradeSubscription: 'Upgrade Subscription',
    myBalance: 'My balance',
    rechargeNow: 'Deposit',
    chooseSubscriptionPackage: 'Choose subscription package',
    balancePurchase: 'Balance purchase',
    subscriptionPrivilege: 'Subscription privilege package',
    unlockCost: 'Unlock price',
    popular: 'Popular',
    pass: 'Pass',
    days: 'Days',
    subscriptionTitle: 'Subscription',
    subscriptionHint: 'Swipe sideways',
    subscriptionDefault: 'Recommended',
    subscriptionDays: '{days} days',
    subscriptionAction: 'Subscribe with this plan',
    subscriptionUnavailable: 'Subscription is unavailable',
    createSubscriptionOrderFail: 'Failed to create subscription order',
    subscriptionSuccess: 'Subscription completed',
    subscriptionCancel: 'Subscription cancelled',
    billingWeekly: 'Weekly',
    billingMonthly: 'Monthly',
    billingHalfYearly: 'Half-Yearly',
    billingYearly: 'Yearly',

    loading: 'Loading...',

    noDataError: 'Episode data error',

    createOrderFail: 'Failed to create order',
    missingOrderId: 'Missing trade_order_id',

    insufficientBalance: 'Insufficient balance. Please Deposit first.',

    paying: 'Processing payment...',
    payCancel: 'Payment cancelled',

    rechargeSuccess: 'Deposit successful',
    rechargeFail: 'Deposit failed or cancelled',
    orderCheckFail: 'Order check failed',
    buySuccess: 'Purchase successful',
    unlockSuccess: 'Unlocked successfully',
    payFail: 'Payment failed',
    payProcessing: 'Payment processing, please check later',
  },
  recharge: {
    currency: 'JPY',
    title: 'Deposit',

    selectAmount: 'Select amount',

    noticeTitle: 'Important Notes',

    notice1: '※ Points are digital goods and are available immediately after purchase.',
    notice2: '※ 1 Bean = 1 coin.',
    notice3: '※ Points, bonus points, and VIP benefits are digital goods.',
    notice4: '※ If a refund is processed, the viewing rights of purchased episodes or series will be revoked based on the refunded amount.',
    notice5: '※ If the refunded amount is less than the total order amount, only the corresponding purchased viewing rights will be revoked.',
    notice6: '※ Remaining points, used points, bonus points, and revoked viewing rights are subject to the platform refund rules.',
    btn: 'Deposit',
    success: 'Payment successful',

    footnote: '※ Points are added instantly after payment.',

    createOrderFail: 'Failed to create order',
    rechargeError: 'Deposit failed',
    processing: 'Payment processing',
    cancelled: 'Payment cancelled',
  },
  subscription: {
    title: 'Subscription',
    loading: 'Loading...',
    empty: 'No plans available',
    loadFail: 'Failed to load subscription plans',
    processing: 'Processing...',
    selectPlan: 'Please select a plan',
    currentSubscription: 'Current subscription',
    current: 'Current',
    status: 'Status',
    validUntil: 'Valid until',
    nextRenewal: 'Next renewal',
    statusActive: 'Active',
    statusCancelledValid: 'Cancelled, valid until expiration',
    statusInactive: 'Inactive',
    reactivate: 'Reactivate subscription',
    upgrade: 'Upgrade subscription',
    unavailable: 'Subscription unavailable',
    currentPlan: 'Current subscription',
    currentPlanToast: 'This is your current subscription',
    changeTip: 'You already have an active subscription. You can switch to another plan.',
    reactivateTip: 'Your subscription is cancelled but still valid. You can reactivate auto-renewal.',
    blockingTip: 'You already have a subscription. New subscription is not available until it expires.',
    cannotReactivate: 'This subscription cannot be reactivated',
    cannotChange: 'Cannot change subscription now'
  },
  checkout: {
    title: 'Payment',
    qrisStandard: 'Indonesian Standard',
    qrisPay: 'QRIS Payment',
    qrisHint: 'Scan with any QRIS-supported banking or e-wallet app.',
    scanTitle: 'Scan to pay',
    scanDesc: 'Use your payment app to scan the QR code and complete the payment.',
    qrAlt: 'Payment QR code',
    qrUnavailable: 'QR code unavailable',
    waiting: 'Waiting for payment',
    paid: 'Payment successful',
    orderNo: 'Order No.',
    cancelPayment: 'Cancel payment',
    cancelled: 'Payment cancelled'
  },
  category: {
    title: 'Categories',
    noData: 'No data',
    loadFail: 'Failed to load categories'
  },
  orderHistory: {
    title: 'Order History',
    empty: 'No orders yet',
    orderNo: 'Order No.',
    amount: 'Amount',
    status: 'Status',
    time: 'Date',
    loading: 'Loading...',
    loadEnd: 'All loaded',
    currency: 'JPY',
    statusMap: {
      completed: 'Completed',
      pending: 'Pending',
      cancelled: 'Cancelled',
      failed: 'Failed'
    },
    productName: 'Product',
    unitCoin: 'Coins'
  },
  tab: {
    home: 'Home',
    category: 'Categories',
    profile: 'Profile'
  },
  banner: {
    hotDramaTitle: 'Popular Dramas',
    title: 'All Short Dramas',
    menu: 'Menu'
  },
  search: {
    searchBtn: "Search",
    pageTitle: "Search",
    placeholder: 'Enter keywords',
    placeInputHolder: 'Search by title or actor',
    popularSearch: 'Popular',
    recentSearch: 'Recent',
    noHistory: 'No history',
    searchResultOf: 'Results for',
    countUnit: 'items',
    noWorks: 'No results found',
    tags: {
        romance: 'Romance',
        suspense: 'Suspense',
        comedy: 'Comedy',
        action: 'Action',
        fantasy: 'Fantasy',
        historical: 'Historical',
        youth: 'Youth',
        family: 'Family',
        revenge: 'Revenge',
        business: 'Business',
        urban: 'Urban',
        campus: 'Campus',
        marriage: 'Marriage',
        sweet: 'Sweet',
        sad: 'Sad',
        inspirational: 'Inspiring',
        mystery: 'Mystery',
        crime: 'Crime',
        thriller: 'Thriller',
        completed: 'Completed',
        ongoing: 'Ongoing',
        new: 'New'
    }
  },
  privacy: {
    title: 'Privacy Policy',
    backLabel: 'Back',
    section1: {
      title: '1. Overview',
      content: 'This Privacy Policy explains how OttDrama handles user data. We comply with applicable laws and protect your personal information properly.'
    },
    section2: {
      title: '2. Data We Collect',
      intro: 'We may collect the following:',
      items: [
        'Account info (email, username)',
        'Usage data (watch history, search, favorites)',
        'Device info (OS, model, app version)',
        'Technical data (IP, cookies, ad IDs)',
        'Support inquiries and records'
      ]
    },
    section3: {
      title: '3. Purpose',
      intro: 'We use data to:',
      items: [
        'Provide and improve the service',
        'Support users',
        'Ensure security',
        'Analyze usage',
        'Introduce new features',
        'Comply with laws'
      ]
    },
    section4: {
      title: '4. Payments',
      para1: 'We may use platforms like Apple App Store or Google Play.',
      para2: 'We do not store your payment details. They are handled by those platforms.'
    },
    section5: {
      title: '5. Third Parties',
      intro: 'We do not share data except:',
      items: [
        'With your consent',
        'Legal requirements',
        'To protect safety or property',
        'For public health or child protection'
      ]
    },
    section6: {
      title: '6. External Services',
      intro: 'We may use:',
      items: [
        'Analytics tools',
        'Ad services',
        'Crash reporting tools'
      ],
      additionalNote: 'These may collect anonymous data.'
    },
    section7: {
      title: '7. Cookies',
      para1: 'We use cookies to improve experience and analyze usage.',
      para2: 'You can disable cookies, but some features may not work.'
    },
    section8: {
      title: '8. Data Security',
      content: 'We take reasonable measures to protect your data.'
    },
    section9: {
      title: '9. Your Rights',
      para1: 'You can request access, correction, or deletion of your data.',
      para2: 'Contact us for requests.'
    },
    section10: {
      title: '10. Minors',
      content: 'Minors must have guardian consent.'
    },
    section11: {
      title: '11. Updates',
      content: 'We may update this policy anytime.'
    },
    section12: {
      title: '12. Contact',
      contactLine1: 'For inquiries:',
      contactLine2: 'Email: duanjushortvideotv@gmail.com'
    },
    effectiveDate: 'Effective: Jan 1, 2026'
  },
  agreement: {
    title: 'Terms of Service',
    backLabel: 'Back',
    section1: {
      title: '1. Scope',
      content: 'These terms apply to OttDrama. By using the service, you agree to them.'
    },
    section2: {
      title: '2. Registration',
      para1: 'Users must register with accurate information.',
      para2: 'We may reject registration if:',
      items: [
        'False information',
        'Past violations',
        'Other concerns'
      ]
    },
    section3: {
      title: '3. Account',
      para1: 'You are responsible for your account.',
      para2: 'We are not liable for misuse.'
    },
    section4: {
      title: '4. Service',
      content: 'We provide short drama content and may update features anytime.'
    },
    section5: {
      title: '5. Paid Content',
      para1: 'Some content is paid.',
      para2: 'Prices and terms are shown in-app.'
    },
    section6: {
      title: '6. Points',
      para1: 'Points may be used for purchases.',
      items: [
        'Usable only in app',
        'Not redeemable for cash',
        'No refunds unless required by law',
        'May expire'
      ]
    },
    section7: {
      title: '7. Payment',
      para1: 'Payments are handled by platforms like Apple/Google.',
      para2: 'No refunds after purchase unless required.'
    },
    section8: {
      title: '8. Prohibited',
      intro: 'Do not:',
      items: [
        'Break laws',
        'Engage in crime',
        'Violate rights',
        'Disrupt service',
        'Use for abuse',
        'Collect user data',
        'Impersonate others',
        'Hack or attempt access',
        'Copy/distribute content',
        'Interfere with operations',
        'Other improper actions'
      ]
    },
    section9: {
      title: '9. IP Rights',
      para1: 'All content belongs to us or licensors.',
      para2: 'No unauthorized use.'
    },
    section10: {
      title: '10. Suspension',
      intro: 'We may suspend accounts if:',
      items: [
        'Terms violated',
        'False info',
        'Payment failure',
        'Other risks'
      ]
    },
    section11: {
      title: '11. Minors',
      content: 'Minors need guardian consent.'
    },
    section12: {
      title: '12. Service Interruptions',
      intro: 'Service may stop due to:',
      items: [
        'Maintenance',
        'Disasters',
        'System failures',
        'Other reasons'
      ]
    },
    section13: {
      title: '13. Disclaimer',
      para1: 'We do not guarantee the service is error-free.',
      para2: 'We are not liable unless due to gross negligence.'
    },
    section14: {
      title: '14. Changes',
      content: 'We may update terms anytime.'
    },
    section15: {
      title: '15. Privacy',
      content: 'We handle data per our Privacy Policy.'
    },
    section16: {
      title: '16. Law',
      content: 'Japanese law applies.'
    },
    section17: {
      title: '17. Contact',
      contactLine1: 'For inquiries:',
      contactLine2: 'Email: duanjushortvideotv@gmail.com',
      contactLine3: 'Hours: Weekdays 10:00–17:00'
    }
  },
  contact: {
    greeting: 'Contact Us',
    subGreeting: 'Inquiries & Support',
    email: 'E-mail',
    whatsapp: 'WhatsApp',
    line: 'LINE',
    copyHint: 'tap to copy',
    copy: 'Copy',
    message: 'Message',
    addFriend: 'Add Friend',
    noteEmail: 'Contact us here',
    noteWhatsapp: 'Business hours: 10:00-18:00',
    noteLine: 'Official account',
    footerNote: '* We usually reply within 24 hours.\n* Please include necessary details when contacting us.',
    toastCopySuccess: 'Copied',
    toastCopyEmail: 'Email address',
    toastCopyWhatsapp: 'WhatsApp number',
    toastCopyLine: 'LINE ID',
    toastShareSuccess: 'Share successful',
    toastShareFail: 'Share failed'
  }
}
